module.exports = __webpack_public_path__ + "media/images/site/marks-left-3be0d6e4344c8f7b5c8bf618aebf1bfe.svg";